<template>
    <section class="container-fluid">
        <div class="row mcas">
            <div class="col-md-6 col-lg-4 main">

                <div class="row" id="opffp"></div>
                <div class="row" id="anof"></div>
                <div class="row" id="dta_ref">
                    <div class="col-12 m-record">
                        <div class="row nav-top">
                            <div class="col-2 xtl"><span class="nav-back wt" onclick="window.location.href='#/'"></span>
                            </div>
                            <div class="col-8 tfw-5 tf-18">Check In</div>
                            <div class="col-2"></div>
                        </div>
                        <div class="row chnbg plr-15">
                            <div class="col-12 pa-0 mt-4 mxui">
                                <div class="row xtc mr-0 mt-4">
                                    <div class="col-12 tfwr">
                                        <div class="dfwpcc tf-16 pb-2">
                                            <div class="wwfa">Day 1</div>
                                            <div class="wwfa">Day 2</div>
                                            <div class="wwfa">Day 3</div>
                                            <div class="wwfa">Day 4</div>
                                        </div>
                                        <div class="dfwpcc">
                                            <div class="wwfa"><span id="rc1" class="rcbox"></span></div>
                                            <div class="wwfa"><span id="rc2" class="rcbox"></span></div>
                                            <div class="wwfa"><span id="rc3" class="rcbox"></span></div>
                                            <div class="wwfa"><span id="rc4" class="rcbox"></span></div>
                                        </div>
                                        <div class="dfwpcc tfcdg tf-18 tfw-6 pt-2 pb-2">
                                            <div class="wwfa">+ 1</div>
                                            <div class="wwfa">+ 1</div>
                                            <div class="wwfa">+ 2</div>
                                            <div class="wwfa">+ 1</div>
                                        </div>
                                    </div>
                                    <div class="col-9 tfwr mt-4">
                                        <div class="dfwpcc tf-16 pb-2">
                                            <div class="wwfa">Day 5</div>
                                            <div class="wwfa">Day 6</div>
                                            <div class="wwfa">Day 7</div>
                                        </div>
                                        <div class="dfwpcc">
                                            <div class="wwfa"><span id="rc5" class="rcbox"></span></div>
                                            <div class="wwfa"><span id="rc6" class="rcbox"></span></div>
                                            <div class="wwfa"><span id="rc7" class="rcbox"></span></div>
                                        </div>
                                        <div class="dfwpcc tfcdg tf-18 tfw-6 pt-2 pb-2">
                                            <div class="wwfa">+ 1</div>
                                            <div class="wwfa">+ 1</div>
                                            <div class="wwfa">+ 3</div>
                                        </div>
                                    </div>
                                    <div class="col-3 mt-4 pa-0">
                                        <div class="xtc mt-2"><span id="rcb" class="rcbox box" ></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 pt-2 xtc">
                                    <div :class="checkstyle" id="cibt" @click="checkin()" >Check In</div>
                                </div>
                            </div>
                            <div class="col-12 mt-4 pt-4">
                                <div class="tf-18 tffss tfs-w">Check in for 7 consecutive days to get treasure box, and
                                    receive mysterious prizes! .<img src="../assets/includes/images/Treasure_b.png"
                                        style="width: 100%;margin-top: -70px;"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>


<script>
import axios from "axios";
export default {
    name: "CheckView",
    data() {
        return {
                username: null,
                check: false,
                checkstyle:'cinBtn dcin',
                days: 0,
                info:'',
                info1:'',
        }

    },
    mounted: function prepare() {
        this.getrecord();
        this.setactive(this.days);
        this.stylecheck();
    },
    methods: {
        stylecheck() {
            if (this.check == 'true') { 
              this.checkstyle='cinBtn dcin act';
            } else {
                 this.checkstyle='cinBtn dcin';
            }
        },
        getrecord() {
            this.username = localStorage.getItem('username');

            axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=getcheckinstatus&user=' + this.username).then((res) => {
                this.info = res.data;
                console.log(this.info);
               
                this.check=this.info[0].status; 
                console.log(this.check);
                this.days=this.info[0].days;
                this.setactive(this.days);
                this.stylecheck();
                console.log(this.checkstyle);
                
            }).catch((err) => {
                console.log(err);
            })
        },
        checkin(){
            axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=checkinuser&user=' + this.username).then((res) => {
                this.info1 = res.data;
                console.log(this.info1);
                console.log(this.info1[0].status);
                alert(this.info1[0].status);
                this.getrecord();
                this.setactive(this.days);
                this.stylecheck();
            }).catch((err) => {
                console.log(err);
            })
        },
        setactive(n) {
            const ids = ["rc1", "rc2", "rc3", "rc4", "rc5", "rc6", "rc7"];
            for (let i = 0; i < n && i < ids.length; i++) {
                const element = document.getElementById(ids[i]);
                if (element) {
                    element.classList.add("act");
                }
            }
        }




    }
}

</script>
